<template lang="">
  <div>
    <div class="news_r_b" style="padding-bottom: 0;">
      <ul>
        <li class="flex flex-between " v-for="item in liebiaos" :key="item.id">
          <router-link
            v-if="isLiuyan"
            class="news_info"
            :to="`/LiuyanInfo/${item.id}`"
            >{{ item.title }}</router-link
          >
          <router-link
            v-else
            class="news_info"
            :to="`/Dxarticles/${item.id}`"
            >{{ item.title }}</router-link
          >
          <span class="news_data">{{ item.created_at }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div class="page" v-if="liebiaos.length > 0">
        <a href="#" @click="go(-1)" class="big_prev">上一页</a>
        <a href="#" @click="go(-1)" class="small_prev">&lt;</a>
        <a
          href="#"
          v-for="(item, index) in pages"
          :key="index"
          @click="select(item)"
          :class="{ active: item == currentPage }"
          >{{ item }}</a
        >
        <a href="#" @click="go(1)" class="big_prev">下一页</a>
        <a href="#" @click="go(1)" class="small_prev">&gt;</a>
      </div>
      <div class="text-center" v-else>
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Lists",
  props: {
    isLiuyan: {
      default: false,
      type: Boolean,
    },
    liebiaos: {
      type: Array,
    },
    totlePage: {
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    select(n) {
      // console.log(typeof(n))
      if (typeof n === "string") {
        return;
      }
      if (typeof n === this.currentPage) {
        return;
      }
      this.currentPage = n;
      console.log("emit", this.currentPage);
      this.$emit("liebiao2", this.currentPage);
    },
    go(k) {
      this.currentPage += k;
      this.currentPage < 1
        ? (this.currentPage = 1)
        : this.currentPage > this.totlePage
        ? (this.currentPage = this.totlePage)
        : null;
      this.$emit("liebiao2", this.currentPage);
    },
  },
  computed: {
    pages() {
      const t = this.totlePage;
      const c = this.currentPage;
      if (t <= 10) {
        return t;
      } else {
        if (c <= 5) {
          return [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", t];
        }
        if (c >= t - 4) {
          return [
            1,
            "...",
            t - 8,
            t - 7,
            t - 6,
            t - 5,
            t - 4,
            t - 3,
            t - 2,
            t - 1,
            t,
          ];
        } else {
          return [
            1,
            "...",
            c - 3,
            c - 2,
            c - 1,
            c,
            c + 1,
            c + 2,
            c + 3,
            "...",
            t,
          ];
        }
      }
    },
  },
  // props: ["liebiaos", "totlePage"],
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
